// Widget Studio — installation detail page (CHG-2463 / ITER-905205, S4).
//
// Thin wrapper: config in @generated/screens/widget-installation-detail,
// regenerated from widget-installation.entity-hint.yaml. The inline
// status-override dialog is driven by WidgetInstallationActionsHost (mounted
// once in App.tsx). Route /channels/widgets/installations/:widgetInstallationId.

import { DetailPage } from "../components/composition";
import { widgetInstallationDetailConfig } from "../generated/screens/widget-installation-detail";

export function WidgetInstallationDetail() {
  return <DetailPage config={widgetInstallationDetailConfig} />;
}
